import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-kamona-number-pad',
  templateUrl: './kamona-number-pad.component.html',
  styleUrls: ['./kamona-number-pad.component.scss']
})
export class KamonaNumberPadComponent implements OnInit {
	padValue: number [] = [];
	@Output() emitKeyPadValueEntered = new EventEmitter();
	@Output() emitKeyPadValueDeleted = new EventEmitter();
	@Output() emitKeyPadValue = new EventEmitter();
	@Output() emitKeyPadValueInArray = new EventEmitter();
	@Input() totalAllowableKeyIndex = 9;
	canSubmitValue: boolean;
	selectKeyPad: number;


	numberPad = [
		{
			pad:{
				keys: [1,2,3]
			}
		},
		{
			pad:{
				keys: [4,5,6]
			}
		},
		{
			pad:{
				keys: [7,8,9]
			}
		},
		{
			pad:{
				keys: ['clear',0,'submit']
			}
		}
	]

  constructor() { }

  ngOnInit(): void {
  }

  setValue(value: any){
		if(this.padValue.length > this.totalAllowableKeyIndex){return;}
		this.padValue.push(value);
		this.selectKeyPad = value;
		const index = this.padValue.length - 1;
		this.emitKeyPadValueEntered.emit({value, index});
		this.isSubmitValue();
  }

  isSubmitValue(){
		const lastIndex = this.padValue.length - 1;
		this.canSubmitValue = lastIndex === this.totalAllowableKeyIndex;
  }

  popValue(){
		const value = this.padValue.pop();
		const index = this.padValue.length;
		this.emitKeyPadValueDeleted.emit({value, index});
		if(!this.padValue.length){
			this.selectKeyPad = -1;
		}
		this.isSubmitValue();
  }

  submit(){
		if(this.canSubmitValue) {
			this.emitKeyPadValueInArray.emit(this.padValue);
			this.emitKeyPadValue.emit(this.getFilteredPadValue());
		}
  }

  getFilteredPadValue(){
		const value = this.padValue.toLocaleString();
		return value.replace(/[,]/g, "");
  }

}
